import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: "📊", path: null, roles: ["admin"] },
  { id: "courses", label: "Courses", icon: "📚", path: null, roles: ["admin"] },
  { id: "partners", label: "Partners", icon: "🤝", path: null, roles: ["admin"] },
  { id: "domains", label: "Skill Domains", icon: "🏫", path: null, roles: ["admin"] },
  { id: "users", label: "Enrolled Users", icon: "👤", path: null, roles: ["admin"] },
  { id: "registered_users", label: "Registered Users", icon: "🧑‍💻", path: null, roles: ["admin"] },
  { id: "jobs_admin", label: "Job Posts", icon: "💼", path: null, roles: ["admin"] },
  { id: "applications", label: "Applications", icon: "📋", path: null, roles: ["admin"] },
  { id: "counsel_admin", label: "Counselling", icon: "🧑‍💼", path: null, roles: ["admin"] },
  {
    id: "testimonials",
    label: "Testimonials",
    icon: "💬",
    path: "/admin/testimonials",
    roles: ["admin"],
  },
  {
    id: "blogs",
    label: "Blogs",
    icon: "📝",
    path: "/admin/blogs",
    roles: ["admin", "blog-admin"],
  },
];

const AdminSidebar = ({ section, onSectionChange }) => {
  const { logout, isAdmin, isBlogAdmin } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const visibleItems = navItems.filter(
    (item) =>
      (isAdmin && item.roles.includes("admin")) ||
      (isBlogAdmin && item.roles.includes("blog-admin")),
  );

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleClick = (item) => {
    if (item.path) {
      // Testimonials ya koi bhi dedicated page — seedha navigate
      navigate(item.path);
    } else {
      // Agar hum /admin pe hain to sirf section change karo (no navigate needed)
      if (location.pathname === "/admin") {
        if (onSectionChange) onSectionChange(item.id);
      } else {
        // Kisi aur page (e.g. /admin/testimonials) se aa rahe hain
        // state ke saath /admin pe navigate karo taaki AdminPage sahi section load kare
        navigate("/admin", { state: { section: item.id } });
      }
    }
  };

  const isActive = (item) => {
    if (item.path) {
      return (
        location.pathname === item.path ||
        location.pathname.startsWith(item.path + "/")
      );
    }
    return section === item.id && location.pathname === "/admin";
  };

  return (
    <div className="admin-sidebar">
      <div className="admin-logo">
        <div className="admin-logo-text">SkillYer Admin</div>
        <div className="admin-logo-sub">Powered by Truhire AI Private Limited</div>
      </div>
      {visibleItems.map((n) => (
        <div
          key={n.id}
          className={`admin-nav-item${isActive(n) ? " active" : ""}`}
          onClick={() => handleClick(n)}
        >
          <span className="admin-nav-icon">{n.icon}</span>
          {n.label}
        </div>
      ))}
      <div
        className="admin-nav-item"
        onClick={handleLogout}
        style={{ marginTop: "auto" }}
      >
        <span className="admin-nav-icon">🚪</span>Logout
      </div>
    </div>
  );
};

export default AdminSidebar;
